import { useCallback } from 'react';

import { plainDtos } from '@abg/shared';
import { useBffClient } from '@abg/web-core/bff/data/client-provider';

export const useGetLocationMessage = () => {
  const bffClient = useBffClient();

  const getLocationMessage = useCallback(
    async (mnemonic: string) => {
      const queryParams = new URLSearchParams({
        mnemonic,
      });

      return await bffClient.refdata<plainDtos.StationDirectionDetails>(
        `/location/station-direction-details?${queryParams}`,
      );
    },
    [bffClient],
  );

  return {
    getLocationMessage,
  };
};
